"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * A Custom Form Control that renders an attractive check box or radio button.
 */
const FormCustomControl = props => {
  const {
    feedbackType,
    id,
    isInvalid,
    inputType,
    label,
    ...rest
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    bsPrefix: `custom-control custom-${inputType}`,
    id: id,
    isInvalid: isInvalid || feedbackType === 'invalid'
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck.Input, _extends({
    "aria-invalid": isInvalid,
    "aria-label": label,
    bsPrefix: "custom-control-input",
    isInvalid: isInvalid || feedbackType === 'invalid',
    type: inputType
  }, rest)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck.Label, {
    bsPrefix: "custom-control-label"
  }, label)));
};
FormCustomControl.propTypes = {
  /**
   * The initial setting of the input's "value".
   */
  checked: _propTypes.default.bool,
  /**
   * The HTML5 validation pattern to set on the Form.Control.
   */
  disabled: _propTypes.default.bool,
  /**
   * The helper text or valid/invalid feedback.
   */
  feedbackType: _propTypes.default.string,
  /**
   * The `ID` for the input & `htmlFor` the label
   */
  id: _propTypes.default.string.isRequired,
  /**
   * The input type
   */
  inputType: _propTypes.default.oneOf(['radio', 'checkbox']).isRequired,
  /**
   * Is the selection valid or invalid.
   */
  isInvalid: _propTypes.default.bool.isRequired,
  /**
   * The label text can be either a string "Form Control Label" or an html element in jsx
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  /**
   * The onChange event callback
   */
  onChange: _propTypes.default.func,
  /**
   * If the input is required
   */
  required: _propTypes.default.bool
};
FormCustomControl.defaultProps = {
  id: 'default-checkbox',
  isInvalid: false
};
var _default = exports.default = FormCustomControl;